class CollectionCategoryList extends HTMLElement {
  constructor() {
    super();
    this.options = this.querySelectorAll('.category-option a');
    this.isb2b = window.isB2B;
    this.paginationLinks = this.closest('.collection-product-grid')?.querySelectorAll('.pagination__item');
    this.aside = this.closest('aside');
    this.initialSections = this.getSections();
    this.initialTitle = document.querySelector('.collection-b2b-header .h1').textContent;
  }

  connectedCallback() {
    this.options.forEach((option) => {
      option.addEventListener('click', this.handleSelect.bind(this));
    });
    if (this.isb2b) this.setupPaginationLinks(this.paginationLinks);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleSelect.bind(this));
  }

  setupPaginationLinks(links) {
    links.forEach((link) => {
      link.addEventListener('click', this.handlePaginationLinkClick);
    });
  }

  setupPaginationOuter() {
    const newLinks = document.getElementById('ProductGridContainer')?.querySelectorAll('.pagination__item');
    if (!newLinks) return;
    this.setupPaginationLinks(newLinks);
  }

  handlePaginationLinkClick = (e) => {
    e.preventDefault();
    this.renderSectionFromFetch(e.currentTarget.href);
  };

  handleSelect(e) {
    e.preventDefault();
    const target = e.currentTarget;
    this.deselectAll(target);
    this.selectCurrent(target);
    const component = this;
    const sections = window.b2bSearchPerformed ? this.initialSections : this.getSections();
    window.b2bSearchPerformed = false;
    const isMainProductGrid = target.closest('#main-collection-filters') && true;
    if (this.isb2b && window.innerWidth < 990) {
      this.aside.classList.toggle('active');
    }
    sections.forEach((section) => {
      const url = `${target.href}?section_id=${section.section}`;
      window.currentCollectionUrl = target.href;
      if (isMainProductGrid && !this.isb2b) {
        window.location.href = target.href;
      } else {
        component.renderSectionFromFetch(url, target);
        target.closest('.collection-product-grid').dataset.collectionUrl = target.href;
      }
    });
  }

  getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  renderSectionFromFetch(url, target) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGridContainer(html, target);
      })
      .then(() => {
        const collectionName = target.dataset.collectionName;
        if (collectionName) document.querySelector('.collection-b2b-header .h1').textContent = collectionName;
      });
  }

  renderProductGridContainer(html) {
    const bundleContainer = document.getElementById('BundleProductGridContainer');
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const newProductGrid = parsedHtml.getElementById('ProductGridContainer');
    if (!newProductGrid) return;
    if (!bundleContainer) {
      if (!this.isb2b) return;
      const productGrid = document.getElementById('ProductGridContainer');
      productGrid.innerHTML = newProductGrid.innerHTML;
      const newLinks = productGrid.querySelectorAll('.pagination__item');
      this.setupPaginationLinks(newLinks);
      const headerHeight = parseInt(
        document.documentElement.style.getPropertyValue('--header-height').replace('px', '')
      );
      const scrollBuffer = 50;
      const productGridTopPosition = productGrid.getBoundingClientRect().top;
      const scrollTo = productGridTopPosition + window.scrollY - headerHeight - scrollBuffer;
      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth',
      });
      return;
    }

    const productGrid = bundleContainer.querySelector('#product-grid');
    const scrollTriggers = bundleContainer.querySelectorAll('.scroll-trigger');
    const customizerCards = bundleContainer.querySelectorAll('.detailed-product-card-main-container.customizer-card');
    const regularCards = bundleContainer.querySelectorAll(
      '.detailed-product-card-main-container:not(.customizer-card)'
    );

    if (productGrid) productGrid.setAttribute('id', 'bundles-product-grid');

    scrollTriggers.forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    customizerCards.forEach((card) => {
      card.parentElement.classList.add('hidden');
    });

    regularCards.forEach((card) => {
      card.parentElement.classList.add('bundle-grid-item');
    });
  }

  deselectAll(target) {
    target
      .closest('.facets__list')
      .querySelectorAll('.category-option')
      .forEach((categoryOption) => {
        categoryOption.classList.remove('active');
      });
  }

  selectCurrent(target) {
    target.parentElement.classList.add('active');
  }
}

class CategoryAnchor extends HTMLElement {
  constructor() {
    super();
    this.aside = this.closest('.collection-b2b-outer').querySelector('aside');
  }
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    const closeButton = this.closest('.collection-b2b-outer').querySelector('.aside-drawer--close');
    closeButton?.addEventListener('click', this.handleClick);
  }

  handleClick = () => {
    this.aside.classList.toggle('active');
  };
}

if (!window.customElements.get('collection-category-list')) {
  window.customElements.define('collection-category-list', CollectionCategoryList);
}

if (!window.customElements.get('category-anchor')) {
  window.customElements.define('category-anchor', CategoryAnchor);
}
